import request from '@/utils/request'
let OrderApi = {
    /*订单列表*/
    orderlist(data, errorback) {
        return request._post('/shop/order.order/index', data, errorback);
    },
    /*自提门店与配送方式列表*/
    orderlistpart(data, errorback) {
        return request._post('/shop/order.order/indexpart', data, errorback);
    },
    /*订单详情*/
    orderdetail(data, errorback) {
        return request._post('/shop/order.order/detail', data, errorback);
    },
    /*门店店员列表*/
    shopClerkList(data, errorback) {
        return request._post('/shop/order.order/shopClerkList', data, errorback);
    },
    /*物流公司列表*/
    expressList(data, errorback) {
        return request._post('/shop/order.order/expressList', data, errorback);
    },
    /*售后管理*/
    orderrefund(data, errorback) {
        return request._post('/shop/order.refund/index', data, errorback);
    },
    // 更改售后状态
    changeRefundStatus(data, errorback) {
        return request._post('/shop/order.refund/changeStatus', data, errorback);
    },
    /*去发货*/
    delivery(data, errorback) {
        return request._post('/shop/order.order/delivery', data, errorback);
    },
    /*确认审核*/
    confirm(data, errorback) {
        return request._post('/shop/order.Operate/confirmCancel', data, errorback);
    },
    /*售后详情*/
    refundDetail(data, errorback) {
        return request._get('/shop/order.refund/detail', data, errorback);
    },
    /*售后审核*/
    Approval(data, errorback) {
        return request._get('/shop/order.refund/audit', data, errorback);
    },
    /*确认收货并退款*/
    receipt(data, errorback) {
        return request._post('/shop/order.refund/receipt', data, errorback);
    },
    /*确认收货并发货*/
    refundDelivery(data, errorback) {
        return request._post('/shop/order.refund/delivery', data, errorback);
    },
    /*核销*/
    extract(data, errorback) {
        return request._post('/shop/order.operate/extract', data, errorback);
    },
    /*修改价格*/
    updatePrice(data, errorback) {
        return request._post('/shop/order.order/updatePrice', data, errorback);
    },
    // 备注
    remarkAdd(data, errorback) {
        return request._post('/shop/order.order/addremark', data, errorback);
    },
    /*批量发货*/
    batchDelivery(data, errorback) {
        return request._get('/shop/order.delivery/csv', data, errorback);
    },
    /*修改快递*/
    updateExpress(data, errorback) {
        return request._post('/shop/order.order/updateExpress', data, errorback);
    },
    /*修改收件地址*/
    updateAddress(data, errorback) {
        return request._post('/shop/order.order/updateAddress', data, errorback);
    },
    /*获取地址*/
    getArea(data, errorback) {
        return request._post('/shop/order.order/getArea', data, errorback);
    },
    /*物流轨迹*/
    getExpressTrack(data, errorback) {
        return request._post('/shop/order.express/track', data, errorback);
    },
    /*确认收货*/
    orderReceipt(data, errorback) {
        return request._post('/shop/order.order/receipt', data, errorback);
    },
    /*确认付款*/
    orderPayment(data, errorback) {
        return request._post('/shop/order.order/payment', data, errorback);
    },
    /*开始配送*/
    distribution(data, errorback) {
        return request._post('/shop/order.order/distribution', data, errorback);
    },
    /*审核付款凭证支付*/
    orderPayImage(data, errorback) {
        return request._post('/shop/order.order/pay_image', data, errorback);
    },
    /*取消订单*/
    cancel(data, errorback) {
        return request._post('/shop/order.order/cancel', data, errorback);
    },
    /*获取订单发货类型*/
    getShipmentType(data, errorback) {
        return request._post('/shop/order.order/getShipmentType', data, errorback);
    },
    /*获取订单商品*/
    getCommodity(data, errorback) {
        return request._post('/shop/order.order/getCommodity', data, errorback);
    },
    /*取消发货*/
    cancelExpress(data, errorback) {
        return request._post('/shop/order.order/cancelExpress', data, errorback);
    },
    /*获取订单物流*/
    getOrderExpress(data, errorback) {
        return request._post('/shop/order.order/getOrderExpress', data, errorback);
    },
    /*获取发票列表*/
    getInvoiceList(data, errorback) {
        return request._post('/shop/order.invoice/index', data, errorback);
    },
    /*获取发票详情*/
    getInvoiceDetail(data, errorback) {
        return request._post('/shop/order.invoice/detail', data, errorback);
    },
    /*发票审核*/
    InvoiceAudit(data, errorback) {
        return request._post('/shop/order.invoice/audit', data, errorback);
    },
    /*订单同步聚水潭erp*/
    syncJushuitan(data, errorback) {
        return request._post('/shop/order.Operate/syncJushuitan', data, errorback);
    },
    /*订单同步万里牛erp*/
    syncWanliniu(data, errorback) {
        return request._post('/shop/order.Operate/syncWanliniu', data, errorback);
    },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/order.js